export default __webpack_public_path__ + "static/media/liked video.8bbe3f02.PNG";